(function () {
  if (window.AtlasFormModalLoaded) return;
  window.AtlasFormModalLoaded = true;

  class AtlasFormModal {
    constructor(root) {
      this.root = root;
      this.modal = root.querySelector('[data-atlas-form-modal]');
      this.triggers = root.querySelectorAll('[data-atlas-form-modal-open]');
      this.closes = root.querySelectorAll('[data-atlas-form-modal-close]');
      this.boundKeydown = this.onKeydown.bind(this);

      if (!this.modal || !this.triggers.length) return;

      this.bindUI();
    }

    bindUI() {
      this.triggers.forEach(
        function (trigger) {
          trigger.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              this.open();
            }.bind(this)
          );
        }.bind(this)
      );

      this.closes.forEach(
        function (closeBtn) {
          closeBtn.addEventListener(
            'click',
            function () {
              this.close();
            }.bind(this)
          );
        }.bind(this)
      );
    }

    open() {
      if (!this.modal) return;

      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }

      this.modal.classList.add('is-open');
      this.modal.setAttribute('open', '');
      this.modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', this.boundKeydown);

      const closeBtn = this.modal.querySelector('[data-atlas-form-modal-close].atlas-form-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      this.modal.removeAttribute('open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.boundKeydown);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-atlas-form-modal-section]').forEach(function (root) {
      if (root.dataset.atlasFormModalInit === 'true') return;
      root.dataset.atlasFormModalInit = 'true';
      new AtlasFormModal(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    const orphanModal = document.getElementById('AtlasFormModal--' + sectionId);
    if (orphanModal) orphanModal.remove();
  });
})();
